package com.bulut.mecitogullari.core.i18n

import kotlinx.browser.window

actual fun systemLanguageCode(): String = window.navigator.language
